<template>
  <div class="dlrBottomBtns">
    <div
      class="dlrBottomBtns-left"
      @click="sendAnimate"
      :class="{ 'fade-in': !value, 'fade-out': value }"
      v-if="hasSmartGuide"
    >
      <div class="dlrBottom-portrait-bg">
        <div class="dlrBottom-portrait-pic">
          <div class="dlrBottom-portrait-pic-box">
            <div :style="{
              background:'url('+womanBlue+')',
              borderRadius:'100%',
              height:'100%',
              backgroundSize:'cover' }" />
          </div>
        </div>
      </div>
      <div class="dlrBottom-portrait-text">
        <p></p>
      </div>
    </div>
    <div class="dlrBottomBtns-right">
      <div class="flex">
        <a class="green-bg" href="javascript:void(0);" @click="goIm">
          <p class="flex">
            <em class="icon-im"></em>
            <span>在线咨询</span>
          </p>
        </a>
        <a class="blue-bg" href="javascript:void(0);" @click="openOrder">
          <p class="flex">
            <em class="icon-inquiry"></em>
            <span>询底价</span>
          </p>
        </a>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
@import '@/assets/scss/modules/BottomBtns.scss';
</style>
<script>
import womanBlue from '@/assets/img/pic/woman-default-blue.png';
import layerManager from '@/services/layer.manager';
import eventBus from '@/services/eventBus.service';
import { mapGetters } from 'vuex';
import utils from '@/utils/util';
import { localStorageService } from '@/services/storage.service';
export default {
  data() {
    return {
      womanBlue,
      isAnimate: false,
    };
  },
  props: {
    // 接收一个布尔值作为prop
    value: {
      type: Boolean,
      default: false,
    },
    hasSmartGuide: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      baseInfo: 'baseInfo',
      functionData: 'functionData',
      phoneCallStatus: 'phoneCall/phoneCallStatus',
      icsShowState: 'busiIcsApp/icsShowState',
      hasIm: 'hasIm',
      isSHowSmartGuide: 'isSHowSmartGuide',
    }),
    displayAdviser() {
      const imInfo = this.functionData.imInfo;
      if (this.hasIm) {
        return imInfo.displayAdviser;
      }
      return null;
    },
  },
  methods: {
    sendAnimate() {
      // 切换布尔值
      const newValue = !this.value;
      this.isAnimate = newValue;
      this.$emit('showGuide', newValue);
      this.$bus.$emit('openSmartGuide');
    },
    openOrder() {
      layerManager.price(0, 0, 'bottomprice', 1);
      eventBus.$emit('toggleGuide', 'pause');
    },
    goIm() {
      if (this.displayAdviser) {
        // 跳转im语音暂停
        eventBus.$emit('toggleGuide', 'pause');
        if (this.isSHowSmartGuide) {
          const expiresDate = new Date().getTime() + 60 * 60 * 1000;
          localStorageService.setItem({
            key: 'isFromIm',
            value: true,
            expires: expiresDate,
          });
        }
        if (utils.browser.isApp) {
          window.location.href = this.displayAdviser.appChatScheme;
        } else {
          window.location.href = this.displayAdviser.linkUrl;
        }
      }
    },
  },
};
</script>
